import React from 'react';
import ActionIconButton from './ActionIconButton';

const ConfirmButton = ({title = 'Confirmar', ...props}) => (
    <ActionIconButton variant="confirm" title={title} {...props}>
        <span className="action-icon-button__label">{title}</span>
    </ActionIconButton>
);

export default ConfirmButton;
